import axios from "@/lib/axios";

const getTerminateCancels = () => {
  return axios.get("/facility/flat_rates/terminate_cancels");
}

export default getTerminateCancels;